module.exports = __webpack_public_path__ + "img/price.8df027e7.svg";